import React from 'react';
import { Switch } from 'react-router';
import { SearchBooking } from 'views/job-costing/search/booking/Index';
import { Documents } from './documents/details/Index';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { Cbls } from './cbls/details/Index';
import { Charges } from './booking/details/Index';
import { Equipments } from './equipments/details/Index';
import { Ets } from './ets/details/Index';
import { Redirect } from 'react-router-dom';
import { SearchCBL } from './search/cbl/Index';
import { SearchDocuments } from './search/documents/Index';
import { SearchEquipment } from './search/equipment/Index';
import { SearchEts } from './search/ets/Index';
import { SearchMain } from './search/general/Index';
import { SearchCustomerInvoices } from './search/customerInvoices/Index';
import { SearchExportJobs } from './search/exportJobs/Index';
import { ExportJobs } from './exportJob/details/Index';
import { RouteWithPermissions } from 'containers/route-with-permissions';

export const JobCostingRouting = () => {
    return (
        <Switch>
            <RouteWithPermissions
                path="/job-costing/booking/:bookingId"
                component={Charges}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/Cbls/:cblId"
                component={Cbls}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/documents/:documentId/:exportjobId?"
                component={Documents}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/exportjobs/:exportJobId"
                component={ExportJobs}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/equipments/:equipmentId"
                component={Equipments}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/ets/:etsId"
                component={Ets}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/search/booking"
                component={SearchBooking}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/search/cbl"
                component={SearchCBL}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/search/documents"
                component={SearchDocuments}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/search/equipment"
                component={SearchEquipment}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
           <RouteWithPermissions
                path="/job-costing/search/ets"
                component={SearchEts}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/search/customer-invoices"
                component={SearchCustomerInvoices}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
             <RouteWithPermissions
                path="/job-costing/search/exportJobs"
                component={SearchExportJobs}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/job-costing/search"
                component={SearchMain}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <Redirect to="/job-costing/search/exportJobs" />
        </Switch>
    );
};